import React, { useContext, useState, useEffect, useRef } from 'react';
import TextInput from '../UI/TextInput';
import { Editor } from "react-draft-wysiwyg";
import draftToHtml from "draftjs-to-html";
import { convertFromRaw, EditorState, convertToRaw, ContentState, convertFromHTML } from "draft-js";
import toolbar from "./config/toolbar";
import "./styles/style.css";
import CustomComponent from "./CustomComponent";
import '../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { stateFromHTML } from 'draft-js-import-html';


const ControlledEditor = ({ htmlContent, templateKey, type, register }) => {

    useEffect(() => {
        setIsMounted(true)
        return () => {
            setIsMounted(false)
        }
    }, [])
    const [isMounted, setIsMounted] = useState(false)

    const createState = (body) => {
        var contentState = stateFromHTML(body);
        return EditorState.createWithContent(contentState);;
    };

    // define the local state, using the createState callback to create the initial value
    const [editorState, setEditorState] = useState(createState(htmlContent));

    // override the local state any time that the props change
    useEffect(() => {
        setEditorState(createState(htmlContent));

    }, [htmlContent]);
    const onEditorStateChange = (editorState) => {
        setEditorState(editorState);
    };
    return (
        isMounted && (
        <>
            <Editor
                editorState={editorState}
                wrapperClassName="demo-wrapper"
                editorClassName="demo-editor"
                onEditorStateChange={onEditorStateChange}
                toolbar={toolbar}
                toolbarCustomButtons={[<CustomComponent templateKey={templateKey} type={type} />]}
            />
            <TextInput
                type="hidden"
                name="body"
                register={register()}
                value={`${draftToHtml(convertToRaw(editorState.getCurrentContent()))}`}
            />
        </>
        )
    );
};

export default ControlledEditor;